import Aside from "./Aside";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Outlet } from 'react-router-dom';  // THIS PART OF OUTLET IS LIKE CHILDREN
import Aside2 from "./Aside2";
import Navbar2 from "./Navbar2";
// YUNG main.js nandito public/assets/js/main.js find mo to // menu.switchMenu('vertical'); ERROR YAN
const Base = () => {
	return (
		<div class="layout-wrapper layout-content-navbar">
			{/* Layout wrapper */}
			<div class="layout-container">

				<Aside2 />



				<div className="layout-page">
					{/* NAVBAR */}
					<Navbar2 />
					<div className="content-wrapper">
						<Outlet />

						{/* FOOTER */}
						<Footer />
						<div className="content-backdrop fade" />
					</div>
				</div>


			</div>

			{/* Overlay */}
			<div className="layout-overlay layout-menu-toggle" />

			{/* Drag Target Area To SlideIn Menu On Small Screens */}
			<div className="drag-target" />
		</div>
	);
};

export default Base;
